var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bars-progress"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "timeline"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "at"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "sliders-up"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "at1",
    serifid: "at"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "rocket"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "pen-to-square"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "pen"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "timer"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "rectangle-vertical-history"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "list-timeline"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "toggle2-on"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-long"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "sliders2-vertical"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "crown"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "skype"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "clock-history"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pencil-simple"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass1",
    serifid: "magnifying-glass"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "cloud-arrow-up"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "box-archive"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "archive"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-list"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "speedometer2"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "link-45deg"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard2-x"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard2-plus"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-plus"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "toggle2-on1",
    serifid: "toggle2-on"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "toggle2-off"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "ph-link"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "sliders-up1",
    serifid: "sliders-up"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "check-double"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "sliders2-vertical1",
    serifid: "sliders2-vertical"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "three-dots-vertical"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-long1",
    serifid: "arrow-right-long"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "at2",
    serifid: "at"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "ph-lightning-fill"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "gem"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "ph-timer-fill"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "patch-check-fill"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "lightning-fill"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "gem1",
    serifid: "gem"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "clock-fill"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "ph-arrows-out-line-vertical-bold"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "ph-check-fill"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconS-group",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,9c0,-1.656 -1.344,-3 -3,-3l-12,0c-1.656,0 -3,1.344 -3,3l0,6c0,1.656 1.344,3 3,3l12,0c1.656,0 3,-1.344 3,-3l0,-6Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.5px",
      strokeDasharray: "3,3,0,0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSGroup);
export default __webpack_public_path__ + "static/media/iconS-group.077697a6affb9cf39f1ebe7df0c0e468.svg";
export { ForwardRef as ReactComponent };